import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom'
import Login from './pages/Login'
import PublicRegistration from './pages/PublicRegistration'
import ActivateAccount from './pages/ActivateAccount'
import ProtectedRoute from './components/ProtectedRoute'
import WelcomePage from './pages/WelcomePage'
import { selectIsAuthenticated, selectUser } from './redux/main/authSlice'
import { AuthenticatedLayout } from './components/AuthenticatedLayout'
import { ThemeProvider } from './components/ThemeProvider'
import { NotificationsProvider } from './context/NotificationsContext'
// Import delle pagine cliente
import CustomerDashboard from './pages/customer/CustomerDashboard';
import CustomerAssistanceRequests from './pages/customer/CustomerAssistanceRequests';
import CustomerAddEditAssistanceRequest from './pages/customer/CustomerAddEditAssistanceRequest';
import CustomerPayments from "./pages/customer/CustomerPayments";
import CustomerPaymentPage from "./pages/customer/CustomerPaymentPage";
import CustomerPaymentResult from "./pages/customer/CustomerPaymentResult";
import CustomerSystems from "./pages/customer/CustomerSystems";
import CustomerProfile from './pages/customer/CustomerProfile';
import CustomersList from './pages/CustomersList'
import Systems from './pages/Systems'
import { useSelector } from 'react-redux'
import AssistanceRequestsNoAI from './pages/AssistanceRequestsNoAI'
import AddEditAssistanceRequestNoAI from './pages/AddEditAssistanceRequestNoAI'
import Notifications from './pages/Notifications'
import Users from './pages/Users'
import Services from './pages/Services'
import JobsCalendar from './pages/JobsCalendar'
import JobScheduling from './pages/JobScheduling'
import EquipmentsList from './pages/EquipmentsList'
import InternalVehiclesList from './pages/InternalVehiclesList'
import ProspectsList from './pages/ProspectsList'
import CustomerInteractionsList from './pages/CustomerInteractionsList'
import CustomersMap from './pages/CustomersMap'
import JobsList from './pages/JobsList'
import SuppliersList from './pages/SuppliersList'
import ProductsList from './pages/ProductsList'
import ProductMovementsList from './pages/ProductMovementsList'
import TempWarehouseList from './pages/TempWarehouseList'
import WarehouseList from './pages/WarehouseList'
import ProductCategoriesList from './pages/ProductCategoriesList'
import CarriersList from './pages/CarriersList'
import JobsSettings from './pages/JobsSettings'
import MaintenancesList from './pages/MaintenancesList'
import BilledJobsList from './pages/BilledJobsList'
import CreateJob from './pages/CreateJob'
import CreateMaintenance from './pages/CreateMaintenance'
import MaintenancesAI from './pages/MaintenancesAI'
import EmployeeJobsList from './pages/EmployeeJobsList'
import EmployeeHoursInsight from './pages/EmployeeHoursInsight'
import EmployeeAppointmentDetail from './pages/EmployeeAppointmentDetail'
import MCPServer from './pages/MCPServer'
import JobsListToBill from './pages/JobsListToBill'
import SummaryHours from './pages/SummaryHours'
import EmployeeAbsencesCalendar from './pages/EmployeeAbsencesCalendar'
import LoadEmployeeHours from './pages/LoadEmployeeHours'
import AppNotifications from './pages/AppNotifications'
import AdminDashboard from './pages/AdminDashboard'
import AgentsList from './pages/AgentsList'
import SupplierOrdersList from './pages/SupplierOrdersList'
import ProductSettingsList from './pages/ProductSettingsList'
import LeadsList from './pages/LeadsList'
import QuotationsList from './pages/QuotationsList'


// Il vecchio indirizzo di modifica della pagina AI apre la stessa richiesta nella pagina ufficio
function RedirectToNoAIEdit() {
  const { id } = useParams();
  return <Navigate to={`/assistanceRequestsNoAI/edit/${id}`} replace />;
}

function App() {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const authUser = useSelector(selectUser);
  const isCustomerUser = authUser && authUser.customerId;
  const isAdminUser = authUser && (authUser.admin === true || authUser.roleLabel === 'admin' || authUser.typeLabel === 'admin');
  
  // Determina dove reindirizzare dopo il login
  const getDefaultRoute = () => {
    // Customer → Dashboard cliente
    if (isCustomerUser) {
      return '/customerDashboard';
    }
    // Admin → Calendario commesse
    if (isAdminUser) {
      return '/jobsCalendar';
    }
    // Altri utenti → Homepage
    return '/';
  };
  
  return (
    <Router>
      <ThemeProvider>
        <NotificationsProvider>
        <Routes>
        {/* Rotte pubbliche */}
        <Route path="/login" element={isAuthenticated ? <Navigate to={getDefaultRoute()} replace /> : <Login />} />
        <Route path="/register" element={isAuthenticated ? <Navigate to={getDefaultRoute()} replace /> : <PublicRegistration />} />
        <Route path="/activate-account" element={<ActivateAccount />} />
        {/* Rotte protette */}
        <Route element={<ProtectedRoute />}>
          <Route element={<AuthenticatedLayout />}>
            <Route path="/" element={<WelcomePage />} />
            <Route path="/customersList" element={<CustomersList />} />
            <Route path="/systems" element={<Systems />} />
            {/* Pagine assistenze "AI" tolte il 30/09/2026 (richiesta #018): i vecchi indirizzi
                portano alle pagine dell'ufficio. I file restano in pages/ */}
            <Route path="/assistanceRequests" element={<Navigate to="/assistanceRequestsNoAI" replace />} />
            <Route path="/assistanceRequestsNoAI" element={<AssistanceRequestsNoAI />} />
            <Route path="/assistanceRequests/new" element={<Navigate to="/assistanceRequestsNoAI/new" replace />} />
            <Route path="/assistanceRequests/edit/:id" element={<RedirectToNoAIEdit />} />
            <Route path="/assistanceRequestsNoAI/new" element={<AddEditAssistanceRequestNoAI />} />
            <Route path="/assistanceRequestsNoAI/edit/:id" element={<AddEditAssistanceRequestNoAI />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/users" element={<Users />} />
            <Route path="/usersList" element={<Users />} />
            <Route path="/Utenti" element={<Users />} />
            <Route path="/services" element={<Services />} />
            <Route path="/servicesList" element={<Services />} />
            <Route path="/Servizi" element={<Services />} />
            <Route path="/jobsCalendar" element={<JobsCalendar />} />
            <Route path="/calendar" element={<JobsCalendar />} />
            <Route path="/equipmentsList" element={<EquipmentsList />} />
            <Route path="/equipments" element={<EquipmentsList />} />
            <Route path="/internalVehiclesList" element={<InternalVehiclesList />} />
            <Route path="/internalVehicles" element={<InternalVehiclesList />} />
            <Route path="/prospectsList" element={<ProspectsList />} />
            <Route path="/prospects" element={<ProspectsList />} />
            <Route path="/customerInteractionsList" element={<CustomerInteractionsList />} />
            <Route path="/interactions" element={<CustomerInteractionsList />} />
            <Route path="/customerInteractions" element={<CustomerInteractionsList />} />
            <Route path="/customersMap" element={<CustomersMap />} />
            <Route path="/customersmap" element={<CustomersMap />} />
            <Route path="/jobsList" element={<JobsList />} />
            <Route path="/jobs" element={<JobsList />} />
            <Route path="/summaryHours" element={<SummaryHours />} />
            <Route path="/jobs/scheduling" element={<JobScheduling />} />
            <Route path="/suppliersList" element={<SuppliersList />} />
            <Route path="/suppliers" element={<SuppliersList />} />
            <Route path="/productsList" element={<ProductsList />} />
            <Route path="/products" element={<ProductsList />} />
            <Route path="/productMovementsList" element={<ProductMovementsList />} />
            <Route path="/productMovements" element={<ProductMovementsList />} />
            <Route path="/supplierOrdersList" element={<SupplierOrdersList />} />
            <Route path="/supplierOrders" element={<SupplierOrdersList />} />
            <Route path="/productSettings" element={<ProductSettingsList />} />
            <Route path="/leadsList" element={<LeadsList />} />
            <Route path="/leads" element={<LeadsList />} />
            <Route path="/quotationsList" element={<QuotationsList />} />
            <Route path="/quotations" element={<QuotationsList />} />
            <Route path="/carriersList" element={<CarriersList />} />
            <Route path="/carriers" element={<CarriersList />} />
            <Route path="/jobsSettings" element={<JobsSettings />} />
            <Route path="/maintenancesList" element={<MaintenancesList />} />
            <Route path="/maintenances" element={<MaintenancesList />} />
            <Route path="/maintenancesAI" element={<MaintenancesAI />} />
            <Route path="/billedJobsList" element={<BilledJobsList />} />
            <Route path="/createJob" element={<CreateJob />} />
            <Route path="/createMaintenance" element={<CreateMaintenance />} />
            
            {/* Rotte cliente */}
            <Route path="/customerDashboard" element={<CustomerDashboard />} />
            <Route path="/customerAssistanceRequests" element={<CustomerAssistanceRequests />} />
            <Route path="/customerAssistanceRequest" element={<CustomerAssistanceRequests />} />
            <Route path="/customerAddEditAssistanceRequest" element={<CustomerAddEditAssistanceRequest />} />
            <Route path="/customerAddEditAssistanceRequest/:id" element={<CustomerAddEditAssistanceRequest />} />
            <Route path="/customerCreateAssistanceRequest" element={<CustomerAddEditAssistanceRequest />} />
            <Route path="/customerPayments" element={<CustomerPayments />} />
            <Route path="/customerMyPayments" element={<CustomerPayments />} />
            <Route path="/customerPaymentPage" element={<CustomerPaymentPage />} />
            <Route path="/customerPaymentResult" element={<CustomerPaymentResult />} />
            <Route path="/customer/new-assistance-request" element={<CustomerAddEditAssistanceRequest />} />
            <Route path="/customer/edit-assistance-request/:id" element={<CustomerAddEditAssistanceRequest />} />
            <Route path="/customerSystems" element={<CustomerSystems />} />
            <Route path="/customerProfile" element={<CustomerProfile />} />
            <Route path="/warehouses" element={<WarehouseList />} />
            <Route path="/productsCategory" element={<ProductCategoriesList />} />
            <Route path="/productscategory" element={<ProductCategoriesList />} />
            <Route path="/carriers" element={<CarriersList />} />
            <Route path="/jobsSettings" element={<JobsSettings />} />
            <Route path="/maintenance/create" element={<CreateMaintenance />} />
            <Route path="/maintenance/edit/:id" element={<CreateMaintenance />} />
            <Route path="/jobsListBilled" element={<BilledJobsList />} />
            <Route path="/jobsListToBill" element={<JobsListToBill />} />
            <Route path="/createJob" element={<CreateJob />} />
            <Route path="/job/edit/:id" element={<CreateJob />} />
            <Route path="/customersmaP" element={<CustomersMap />} />
            <Route path="/CustomersMap" element={<CustomersMap />} />
            <Route path="/customerMap" element={<CustomersMap />} />
            <Route path="/CustomerMap" element={<CustomersMap />} />
            
            {/* Nuove rotte per l'area dipendenti */}
            <Route path="/employeeJobsList" element={<EmployeeJobsList />} />
            {/* Reindirizzamento per gestire URL con trattini */}
            <Route path="/employee-jobs-list" element={<Navigate to="/employeeJobsList" replace />} />
            <Route path="/employeeHoursInsight" element={<EmployeeHoursInsight />} />
            <Route path="/employee-appointment-detail/:appointmentId" element={<EmployeeAppointmentDetail />} />
            <Route path="/employeeAbsences" element={<EmployeeAbsencesCalendar />} />
            <Route path="/loadEmployeeHours" element={<LoadEmployeeHours />} />
            
            {/* Rotta per Push Notifications App Mobile */}
            <Route path="/appNotifications" element={<AppNotifications />} />
            
            {/* Rotta per MCP Server */}
            <Route path="/apps/mcp-server" element={<MCPServer />} />
            
            {/* Rotta per Agenti AI */}
            <Route path="/agentsList" element={<AgentsList />} />

            {/* Rotta per Admin Dashboard */}
            <Route path="/adminDashboard" element={<AdminDashboard />} />
            <Route path="/adminDashobard" element={<AdminDashboard />} />
          </Route>
        </Route>
      </Routes>
        </NotificationsProvider>
    </ThemeProvider>
  </Router>
  );
}

export default App
